import { Mail, MessageCircle, Phone } from 'lucide-react'

import { SNOOTS_US } from '@snootsvet/shared'

import { Card, CardContent } from '@/customer/components/ui/card'

const callDigits = SNOOTS_US.phone.replace(/\D/g, '')
const textDigits = SNOOTS_US.textPhone.replace(/\D/g, '')

/** Call and text links for US members. Unstyled list for embedding in any container. */
export function USContactLinks() {
  return (
    <div className="flex flex-col gap-1.5 text-sm font-medium">
      <a href={`tel:${callDigits}`} className="inline-flex items-center gap-2 hover:underline">
        <Phone className="size-4 shrink-0" />
        Call {SNOOTS_US.phone}
      </a>
      <a href={`sms:${textDigits}`} className="inline-flex items-center gap-2 hover:underline">
        <MessageCircle className="size-4 shrink-0" />
        Text {SNOOTS_US.textPhone}
      </a>
      <a
        href={`mailto:${SNOOTS_US.email}`}
        className="inline-flex items-center gap-2 hover:underline"
      >
        <Mail className="size-4 shrink-0" />
        {SNOOTS_US.email}
      </a>
    </div>
  )
}

/** Static contact card for US members showing call and text numbers. */
export function USContactDetails() {
  return (
    <Card color="muted">
      <CardContent>
        <p className="font-bold">Get in touch with the care team</p>
        <USContactLinks />
      </CardContent>
    </Card>
  )
}
